import { render } from "./AppSolicitudesVendor.vue?vue&type=template&id=ff92d7d4&scoped=true"
import script from "./AppSolicitudesVendor.vue?vue&type=script&lang=js"
export * from "./AppSolicitudesVendor.vue?vue&type=script&lang=js"

import "./AppSolicitudesVendor.vue?vue&type=style&index=0&id=ff92d7d4&scoped=true&lang=css"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff92d7d4"]])

export default __exports__